module.exports = __webpack_public_path__ + "static/media/icita2022.b1e5f3c4.png";